<template>
  <BaseModal :show="show" size="sm" :title="title" aria-label="Notificación" @close="closeNotification">
    <div class="flex items-start gap-3">
      <component
        :is="iconComponent"
        class="mt-0.5 h-6 w-6 shrink-0"
        :class="iconColorClass"
        aria-hidden="true"
      />

      <div class="min-w-0 flex-1">
        <p class="text-sm leading-relaxed text-gray-700">
          {{ message }}
        </p>

        <div v-if="details" class="mt-3 rounded-lg border border-gray-200 p-3">
          <p class="text-sm text-gray-600">
            <strong>Detalles:</strong> {{ details }}
          </p>
        </div>
      </div>
    </div>

    <template #footer>
      <BaseButton data-autofocus @click="closeNotification">
        Entendido
      </BaseButton>
    </template>
  </BaseModal>
</template>

<script setup>
import { computed } from 'vue'
import {
  ExclamationTriangleIcon,
  CheckCircleIcon,
  InformationCircleIcon,
  XCircleIcon
} from '@heroicons/vue/24/outline'
import BaseModal from './BaseModal.vue'
import BaseButton from './BaseButton.vue'

const props = defineProps({
  show: {
    type: Boolean,
    default: false
  },
  type: {
    type: String,
    default: 'error',
    validator: (value) => ['success', 'error', 'warning', 'info'].includes(value)
  },
  title: {
    type: String,
    required: true
  },
  message: {
    type: String,
    required: true
  },
  details: {
    type: String,
    default: ''
  }
})

const emit = defineEmits(['close'])

const iconComponent = computed(() => {
  const icons = {
    success: CheckCircleIcon,
    error: XCircleIcon,
    warning: ExclamationTriangleIcon,
    info: InformationCircleIcon
  }
  return icons[props.type]
})

const iconColorClass = computed(() => {
  const colors = {
    success: 'text-green-700',
    error: 'text-red-700',
    warning: 'text-amber-700',
    info: 'text-primary-600'
  }
  return colors[props.type]
})

const closeNotification = () => {
  emit('close')
}
</script>
